import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import Global from '../../../store/global-selectors';
import { FormattedMessage } from 'react-intl';
import { SalesOrderStatusService } from '../../../services/sales-order-status-service';

const StatusComponent = ({ salesOrderId }) => {
  const fulfillmentPlans = useSelector((state) =>
    Global.selectEntitiesFulfillmentPlansBySalesOrderIds(state, {
      salesOrderIds: [salesOrderId],
    }),
  );
  const status = SalesOrderStatusService.getSalesOrderStatus(fulfillmentPlans);
  const statusMessageDescriptor = status?.translation;
  const displayStatus = statusMessageDescriptor ? <FormattedMessage {...statusMessageDescriptor} /> : '';
  return displayStatus;
};
StatusComponent.propTypes = {
  salesOrderId: PropTypes.string.isRequired,
};

export const Status = {
  getName: () => <FormattedMessage defaultMessage='Status' description='customerOrdersGrid.columns.status' id='etSJ1u' />,
  id: 'status',

  render: (data) => {
    if (!data) {
      return '';
    }

    return <StatusComponent salesOrderId={data.salesOrderId} />;
  },
};
